import { render } from "./SitzungDetailsTagesordnung.pug?vue&type=template&id=2ed45aaa&lang=pug"
import script from "./SitzungDetailsTagesordnung.js?vue&type=script&lang=js"
export * from "./SitzungDetailsTagesordnung.js?vue&type=script&lang=js"

import "./SitzungDetailsTagesordnung.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__